// modules/grupos/services/grupoService.js
import axios from "../../../config/axiosConfig";

const BASE = "/api/grupos";

// ── GRUPOS ────────────────────────────────────────────────────
export const getAll        = (params)       => axios.get(BASE, { params });
export const getById       = (id)           => axios.get(`${BASE}/${id}`);
export const create        = (data)         => axios.post(BASE, data);
export const update        = (id, data)     => axios.put(`${BASE}/${id}`, data);
export const remove        = (id)           => axios.delete(`${BASE}/${id}`);
export const buscar        = (q)            => axios.get(`${BASE}/buscar`, { params: { q } });

// ── SUB-GRUPOS ────────────────────────────────────────────────
export const getSubGrupos     = (idGrupo)            => axios.get(`${BASE}/${idGrupo}/sub-grupos`);
export const getSubGrupoById  = (idGrupo, idSub)     => axios.get(`${BASE}/${idGrupo}/sub-grupos/${idSub}`);
export const createSubGrupo   = (idGrupo, data)      => axios.post(`${BASE}/${idGrupo}/sub-grupos`, data);
export const updateSubGrupo   = (idGrupo, idSub, data) => axios.put(`${BASE}/${idGrupo}/sub-grupos/${idSub}`, data);
export const removeSubGrupo   = (idGrupo, idSub)     => axios.delete(`${BASE}/${idGrupo}/sub-grupos/${idSub}`);

// ── VEHÍCULOS DEL SUB-GRUPO ───────────────────────────────────
export const getVehiculosSubGrupo  = (idGrupo, idSub) =>
  axios.get(`${BASE}/${idGrupo}/sub-grupos/${idSub}/vehiculos`);

export const getVehiculosDisponibles = (idGrupo, idSub) =>
  axios.get(`${BASE}/${idGrupo}/sub-grupos/${idSub}/vehiculos/disponibles`);

export const asignarVehiculos = (idGrupo, idSub, ids_rel_vehiculo) =>
  axios.post(`${BASE}/${idGrupo}/sub-grupos/${idSub}/vehiculos`, { ids_rel_vehiculo });

export const desasignarVehiculo = (idGrupo, idSub, idRelVehiculo) =>
  axios.delete(`${BASE}/${idGrupo}/sub-grupos/${idSub}/vehiculos/${idRelVehiculo}`);